var map = {
	"./N1.png": 470,
	"./N2.png": 471,
	"./N3.png": 472,
	"./N4.png": 473,
	"./N5.png": 474,
	"./N6.png": 475,
	"./N7.png": 476,
	"./S1.png": 477,
	"./S2.png": 478,
	"./S3.png": 479,
	"./ohne.png": 244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1814;